<template lang="pug">
  vm-prompt(@vm-cancel="close"  vm-size="large" :vm-buttons-hidden="true" @vm-close="close" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-active="isModalSalesCustomerVisible" :vm-title='title')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        vm-table(:data="salesCustomer")
          template(slot="thead")
            vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('sales.' + column) }}
          template.center(slot-scope="{data}")
            vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
              vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                .row(@click="showSalesDetail(data[indextr])")
                  slot(v-if="column == 'total_mn' || column == 'unit_price' || column == 'total'")  {{data[indextr][column] | currency }}
                  slot(v-if="column != 'status' && column != 'total_mn' && column != 'total' && column != 'unit_price' && column != 'customer_id' && column != 'created_by_id' && column != 'currency_id' && column !== 'attachments' && column !== 'order_customer'") {{data[indextr][column] }}
                  slot(v-if="column == 'customer_id'") {{data[indextr]['customer']['tradename'] }}
                  slot(v-if="column == 'order_customer'") {{data[indextr]['quotation']['order_customer'] }}
                  slot(v-if="column == 'created_by_id'") {{data[indextr]['created_by'] ? data[indextr]['created_by']['name'] : ''}}
                  slot(v-if="column == 'currency_id'") {{data[indextr]['currency']['code']}}
                  vm-chip(v-if="column == 'status'" :color="colorStatus(data[indextr]['status'])") {{data[indextr]['status_display']}}
        vm-pagination(:total="paginationSalesCustomer.totalPages" v-model="currentPage" goto)
                  //- More actions
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Dashboard')
export default {
  name: 'ModalSalesCustomer',
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    paymentDate: '',
    currentPage: 1,
    columns: [
      'folio',
      'customer_id',
      'quotation_folio',
      'order_customer',
      'created_by_id',
      'total_mn',
      'total',
      'currency_id',
      'status'
    ],
    status: [
      {
        text: 'Vendido',
        value: 1,
        color: 'primary'
      },
      {
        text: 'Facturado',
        value: 2,
        color: 'warning'
      },
      {
        text: 'Pagado',
        value: 3,
        color: 'success'
      },
      {
        text: 'Pagado parcialmente',
        value: 4,
        color: '#FFD000'
      }
    ]
  }),
  computed: {
    ...mapGetters([
      'isModalSalesCustomerVisible',
      'salesCustomer',
      'paginationSalesCustomer'
    ]),
    title () {
      return 'Resumen de las ventas'
    }
  },
  watch: {
    isModalSalesCustomerVisible (flag) {
      if (flag) {
        this.loadSalesCustomer({ customer_id: this.id, page: this.currentPage })
      }
    },
    currentPage (currentPage) {
      this.loadSalesCustomer({ page: currentPage, customer_id: this.salesCustomer.id })
    }
  },
  methods: {
    ...mapActions([
      'loadSalesCustomer',
      'setModalSalesCustomerVisible'
    ]),
    colorStatus (code) {
      switch (code) {
        case 1:
          return 'primary'
        case 2:
          return 'warning'
        case 3:
          return 'success'
        case 4:
          return '#FFD000'
        default:
          return '#FFD000'
      }
      // return this.status.find(e => e.value === parseInt(code))['color']
    },
    showSalesDetail (sales) {
      this.close()
      let id = sales.id
      setTimeout(() => {
        this.$router.push({ name: 'salesDetailsShow', params: { id } })
      }, 200)
    },
    close () {
      this.setModalSalesCustomerVisible(false)
    }
  }
}
</script>

<style lang="scss">
.vm-select--options {
  z-index: 400331 !important;
}
a {
  cursor: pointer;
}
.center {
  .tr-table {
    td {
      text-align: center !important;
    }
  }
}
</style>
